module.exports = __webpack_public_path__ + "static/media/no-image.fc20613a.jpg";